import { useEffect, useRef, useState } from "react";

export function ConfirmIconButton({
  label,
  confirmLabel,
  onConfirm,
  children,
  className = "",
  confirmTimeoutMs = 5000,
  type = "button",
  ...props
}) {
  const [armed, setArmed] = useState(false);
  const timerRef = useRef(null);

  const disarm = () => {
    setArmed(false);
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
  };

  useEffect(() => () => {
    if (timerRef.current) clearTimeout(timerRef.current);
  }, []);

  const arm = () => {
    setArmed(true);
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(disarm, confirmTimeoutMs);
  };

  const handleClick = (event) => {
    if (!armed) {
      arm();
      return;
    }
    disarm();
    onConfirm(event);
  };

  const activeLabel = armed ? confirmLabel : label;

  return (
    <button
      type={type}
      className={[
        "icon-button",
        "has-tooltip",
        "icon-button--confirm",
        armed ? "icon-button--armed" : "",
        className,
      ].filter(Boolean).join(" ")}
      aria-label={activeLabel}
      aria-pressed={armed}
      onClick={handleClick}
      onBlur={(event) => {
        if (!event.currentTarget.contains(event.relatedTarget)) disarm();
      }}
      {...props}
    >
      {children}
      <span className="icon-button-tooltip" aria-hidden="true">{activeLabel}</span>
    </button>
  );
}
